import callApi from "helpers/callApi";

export function getRegistrationTrackers() {
  return callApi("/registration_tracker", "GET");
}

export function getRegistrationTracker(trackerId) {
  return callApi(`/registration_tracker/${trackerId}`, "GET");
}

export function getRegistrationTrackerHistory(trackerId) {
  return callApi(`/registration_tracker/${trackerId}/history`, "GET");
}

export function postRegistrationTracker(body) {
  return callApi("/registration_tracker", "POST", body);
}

export function putRegistrationTracker(trackerId, body) {
  return callApi(`/registration_tracker/${trackerId}`, "PUT", body);
}

export function deleteRegistrationTracker(trackerId) {
  return callApi(`/registration_tracker/${trackerId}`, "DELETE");
}

export function getRegistrationTrackerStates(countryId) {
  return callApi("/registration_tracker/states", "GET", { country_id: countryId });
}

export function getRegistrationTrackerTypes() {
  return callApi("/registration_tracker/types", "GET");
}
